<div
  routerLink="/bonus-wheel"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
  class="bonus-wheel-banner group flex h-[45.1rem] w-[57.2rem] cursor-pointer items-start overflow-hidden rounded-[2.4rem] bg-[linear-gradient(194deg,#4527B0_2.8%,#D04DFF_97.7%)] p-[2.4rem] custom-transition-all custom-transition-bg before:bg-[linear-gradient(194deg,#5636CC_2.8%,#D86EFF_97.7%)] lg:h-[21rem] lg:w-full lg:rounded-[1.4rem] lg:px-[1.6rem] lg:pt-[2rem]"
>
  <div class="flex w-full items-center justify-between">
    <div class="flex flex-col space-y-[0.2rem] lg:space-y-0">
      <span
        i18n="@@main.bonuswheel.title"
        class="text-[2rem] font-450 leading-[2.6rem] text-white lg:text-[1.5rem] lg:leading-[2.2rem]"
        >Колесо Бонусов</span
      >
      <span
        i18n="@@main.bonuswheel.desc"
        class="text-[1.3rem] font-350 leading-[1.6rem] text-light-600 opacity-80 lg:text-[1rem] lg:leading-[1.4rem]"
        >Крути колесо и выигрывай крутые призы</span
      >
    </div>
    @if (authState.user()) {
      @if (spinsCount() > 0) {
        <div class="flex items-center space-x-[1rem]">
          <span
            i18n="@@main.bonuswheel.scrolls"
            class="max-w-[6.6rem] text-right text-[1rem] font-450 uppercase leading-[1.4rem] text-white lg:text-[0.8rem] lg:leading-[1.2rem]"
            >У вас прокрутов
          </span>
          <div
            class="flex h-[2.4rem] min-w-[2.4rem] items-center justify-center rounded-full bg-[#F92529] px-[0.7rem] lg:h-[1.8rem] lg:min-w-[1.8rem] lg:shrink-0 lg:px-[0.4rem]"
          >
            <span class="text-[1.3rem] font-400 leading-[1.2rem] text-white lg:text-[1.1rem] lg:leading-[1rem]">{{
              spinsCount()
            }}</span>
          </div>
        </div>
      } @else {
        <span
          i18n="@@main.bonuswheel.noscrolls"
          class="max-w-[6.6rem] text-right text-[1rem] font-450 uppercase leading-[1.4rem] text-white lg:text-[0.8rem] lg:leading-[1.2rem]"
          >У вас НЕТ прокрутов
        </span>
      }
    }
  </div>
  <div
    class="absolute bottom-[4.3rem] right-[2.4rem] z-[5] flex h-[11rem] w-[11rem] items-center justify-center rounded-full bg-[linear-gradient(180deg,#CFA1FF_0%,#FFF_100%)] lg:bottom-[1rem] lg:right-[0.7rem] lg:h-[6.6rem] lg:w-[6.6rem]"
  >
    <div
      class="relative flex h-full w-full items-center justify-center rounded-full border-[0.4rem] border-solid border-[rgba(255,255,255,0.25)]"
    >
      <span class="text-[1.3rem] font-450 leading-[1.6rem] text-[#4F2B60] lg:text-[0.9rem] lg:leading-[1.4rem]">
        SPIN
      </span>
      <img
        #spinArrows
        loading="lazy"
        fetchpriority="low"
        class="pointer-events-none absolute w-[8.1rem] lg:w-[4.8rem]"
        src="/assets/images/main/banners/bonus-wheel/spinArrows.webp"
      />
    </div>
  </div>
  <div class="bonus-wheel__girl"></div>

  <div class="mask lg:[11rem] absolute bottom-0 right-0 z-[3] h-[32rem] w-[31rem] lg:w-[15rem]">
    <div #wheel class="bonus-wheel__wheel"></div>
  </div>
  <img
    loading="lazy"
    fetchpriority="low"
    class="pointer-events-none absolute bottom-0 left-0 h-[45rem] w-[36rem] lg:hidden"
    src="/assets/images/main/banners/bonus-wheel/shadow.webp"
  />
  <img
    loading="lazy"
    fetchpriority="low"
    class="pointer-events-none absolute bottom-0 left-0 hidden lg:flex"
    src="/assets/images/main/banners/bonus-wheel/shadowMob.webp"
  />
  <img
    loading="lazy"
    fetchpriority="low"
    class="pointer-events-none absolute bottom-[14.8rem] left-[14rem] h-[9.44rem] w-[11.7rem] lg:bottom-[4rem] lg:left-[7.4rem] lg:h-[5.41rem] lg:w-[6.5rem]"
    src="/assets/images/main/banners/bonus-wheel/promo.webp"
  />
  <img
    loading="lazy"
    fetchpriority="low"
    class="pointer-events-none absolute left-[20rem] top-[10rem] h-[12.7rem] w-[12.5rem] lg:left-[11.6rem] lg:top-[7rem] lg:h-[5.85rem] lg:w-[5.84rem]"
    src="/assets/images/main/banners/bonus-wheel/gun.webp"
  />
  <img
    loading="lazy"
    fetchpriority="low"
    class="pointer-events-none absolute right-[17rem] top-[6rem] h-[8rem] w-[9rem] lg:right-[12.8rem] lg:top-[4.9rem] lg:h-[4rem] lg:w-[4rem]"
    src="/assets/images/main/banners/bonus-wheel/lvl.webp"
  />
  <img
    loading="lazy"
    fetchpriority="low"
    class="pointer-events-none absolute bottom-0 left-0 z-[4] w-full"
    src="/assets/images/main/banners/bonus-wheel/smoke.webp"
  />
</div>
